// extracted by mini-css-extract-plugin
module.exports = {"notFound":"__404_notFound___KiOk"};